import React , { useEffect, useState } from 'react'; 
import storage from '../factory/StorageFactory.js';
import FormContainer from '../components/FormContainer.jsx';
import config from '../appconfig/config.json';
import helper from '../factory/Helper';
import { FaCheck, FaTimes } from 'react-icons/fa';

const InvalidEntity = (props) => {

    const [displayErrMsg,setDisplayErrMsg] = useState({title:'', errMsg:'', btnType:'',code:''})

    const myInfoError= {
        Code_777:'777',  //Corporate Shareholder, same as M17
        Code_778:'778', //same as M13
        Code_779:'779',  // same as M14
        Code_780:'780', //simulator profile data issue
        Code_M01:'M01', //myinfo unsuccessful
        Code_M02:'M02', // missing myinfo fields
        Code_M03:'M03', // myinfo DOB format
        Code_M04:'M04', // invalid residential status
        Code_M05:'M05', // Non Live
        Code_M06:'M06', // existing record
        Code_M07:'M07', // invalid enitity types (i.e other than Partner, Sole Prop, Limited Liability Partnership, Local Companies)
        Code_M07HA:'M07HA', // invalid enitity types (i.e other than Partner, Sole Prop, Limited Liability Partnership, Local Companies)
        Code_M08:'M08', // blacklist industry on SSIC list
        Code_M09:'M09', // should not be here, M09 should be upon submission
        Code_M10:'M10', // will redirect to Invalid Director Screen from MyInfoLanding
        Code_M11:'M11', // should not be here, M11 should be upon submission
        Code_M13:'M13', // should not be here, M13 should be upon submission
        Code_M14:'M14', // no longer checking
        Code_M17:'M17',
        Code_M20:'M20', //WAA+6 Months
        Code_M24:'M24', //
        Code_M27:'M27',
        Code_M28:'M28'
    }

    const btnType = {
        GetInTouch:'GetInTouch',
        ResumeApp:'ResumeApp',
        BacktoHome:'BacktoHome'
    }

    useEffect(() => {
        window.scrollTo(0,0);
        setDisplayErrorMsg();
        storage.clearAll();
     }, []);

     const handleResumeAppClick = () => {
        window.location.href = helper.getConsentPageUrl();
     }

     const handleGetInTouchClick = () =>{
        window.location.href = config.link.GetInTouch;
    }

    const handleCancelClick = ()=> {
        window.location.href = config.link.Cancle;
    }

    const handleBacktohomeClick = () => {
        window.location.href = config.link.BacktoHome;
    }

    const setDisplayErrorMsg = () => {
        let invalid = {
            title:'',
            errMsg:'',
            btnType:'',
            code:''
        }
        if(props.location.state !== undefined) {
            let errType = props.location.state.errType;
            if(errType === config.ErrType.NonLive) {
                invalid.title = 'Oops!';
                invalid.errMsg = 'We could not find your business records in ACRA.\nDo register your business with ACRA and reapply with us.';
                invalid.btnType = btnType.GetInTouch;
                invalid.code = errType;
            }
            else if(errType === config.ErrType.EmptyCompDtls || errType === config.ErrType.EmptyAPDtls || errType === myInfoError.Code_780) {
                invalid.title = 'Oops!';
                invalid.errMsg = "We are unable to proceed your application online.";
                invalid.btnType = btnType.GetInTouch;
                invalid.code = errType;
            }
            else if(errType === config.ErrType.GetStatusFailed) {
                invalid.title = 'Oops!';
                invalid.errMsg = "Something went wrong. Unable to proceed the status enquiry.";
                invalid.btnType = btnType.GetInTouch;
                invalid.code = errType;
            }
            else if(errType === config.ErrType.ConsentFailed) {
                invalid.title = 'Oops!';
                invalid.errMsg = 'Your application is currently on hold.\n We will get in touch with you within 2 days once we have received all the required information.';
                invalid.btnType = btnType.GetInTouch;
                invalid.code = errType;
            }
            else if(errType === myInfoError.Code_M01) {
                invalid.title = 'Oops!';
                invalid.errMsg = 'Your log in to Myinfo is unsuccessful. <Code '+errType+'>';
                invalid.btnType = btnType.GetInTouch;
                invalid.code = errType;
            }
            else if(errType === myInfoError.Code_M03) {
                invalid.title = 'Oops!';
                invalid.btnType = btnType.BacktoHome;
                invalid.errMsg = 'Your date of birth is incomplete or in the wrong format.\nDo update your details in Myinfo and reapply with us. <Code '+errType+'>';
                invalid.code = errType;
            }
            else if(errType === myInfoError.Code_M04) {
                invalid.title = 'Oops!';
                invalid.btnType = btnType.BacktoHome;
                invalid.errMsg = 'We are unable to retrieve the required information.\nDo update your details in Myinfo and reapply with us. <Code '+errType+'>';
                invalid.code = errType;
            }
            else if(errType === myInfoError.Code_M05) {
                invalid.title = 'Oops!';
                invalid.btnType = btnType.GetInTouch;
                invalid.errMsg = 'We could not find your business records in ACRA.\nDo register your business with ACRA and reapply with us. <Code '+errType+'>';
                invalid.code = errType;
            }
            else if(errType === myInfoError.Code_M06) {  // pending in ODUS, not submitted yet to WAA
                invalid.title = 'Oops!';
                invalid.btnType = btnType.ResumeApp;
                invalid.errMsg = 'We found an existing application in our records.\nPlease resume your existing application. <Code '+errType+'>';
                invalid.code = errType;
            }
            else if(errType === myInfoError.Code_M07) {
                invalid.title = 'Thank you for your interest.';
                invalid.btnType = btnType.GetInTouch;  //BTL - GetInTouch 
                invalid.errMsg = 'We are unable to process your application online. Your Business type is not eligible for this application. <Code '+errType+'>\nFor assistance, do get in touch.';
                invalid.code = errType;
            }
            else if(errType === myInfoError.Code_M07HA) {
                invalid.title = 'Thank you for your interest.';
                invalid.btnType = btnType.GetInTouch;  //Hybrid or AIP - BacktoHome
                invalid.errMsg = 'We are unable to process your application online. Your Business type is not eligible for this application. <Code '+'M07'+'>\nFor assistance, do get in touch.';
                invalid.code = errType;
            }
            else if(errType === myInfoError.Code_M08) { //both myinfo retrival and upon submission
                invalid.title = 'Thank you for your interest.';
                invalid.btnType = btnType.BacktoHome;
                invalid.errMsg = 'We are unable to process your request.\nThe financing requirement is not met. <Code '+errType+'>';
                invalid.code = errType;
            }
            else if(errType === myInfoError.Code_M09) {  //should be upon submission
                invalid.title = 'Thank you for your interest.';
                invalid.btnType = btnType.BacktoHome;
                invalid.errMsg = 'Your application is unsuccessful.\nTo apply online, a minimum of S$100,000 turnover is required. <Code '+errType+'>';
                invalid.code = errType;
            }
            else if(errType === myInfoError.Code_M11) {//should be upon submission
                invalid.title = 'Oops!';
                invalid.btnType = btnType.GetInTouch;
                invalid.errMsg = 'Your application is unsuccessful. Your business turnover has exceeded the maximum eligibility of S$20Mil. <Code '+errType+'>\nGet in touch with us for assistance.';
                invalid.code = errType;
            }
            else if(errType === myInfoError.Code_779  || errType === myInfoError.Code_M14) {  //no longer needed
                invalid.title = 'Oops!';
                invalid.btnType = btnType.BacktoHome;
                invalid.errMsg = 'Your application is unsuccessful. You have a pending application in our records. <Code '+errType+'>';
                invalid.code = errType;
            }
            else if(errType === myInfoError.Code_777 || errType === myInfoError.Code_M17) {//should be upon submission
                invalid.title = 'Oops!';
                invalid.errMsg = 'We are unable to process your application online.\nFor assistance, do get in touch.<Code '+errType+'>';
                invalid.btnType = btnType.GetInTouch;
                invalid.code = errType;
            }
            else if(errType === myInfoError.Code_778 || errType === myInfoError.Code_M13 || errType === myInfoError.Code_M20) {  //application is submitted to WAA + 6 month with App status: LP, LI, LA, DI, DC,RJ
                invalid.title = 'Oops!';
                invalid.btnType = btnType.BacktoHome;
                invalid.errMsg = 'Your application is unsuccessful. <Code '+errType+'>\nYou may reapply twelve months after your last application.';
                invalid.code = errType;
            }
            else if(errType === myInfoError.Code_M24) {
                invalid.title = 'Thank you for your interest.';
                invalid.errMsg = 'We are unable to process your request. The financing requirement is not met.\n<Code '+errType+'>';
                invalid.btnType = btnType.BacktoHome;
                invalid.code = errType;
            }
            else if(errType === myInfoError.Code_M27) {
                invalid.title = 'Oops!';
                invalid.errMsg = 'We are unable to process your online application. <Code '+errType+'>';
                invalid.btnType = btnType.GetInTouch;
                invalid.code = errType;
            }
            else if(errType === myInfoError.Code_M28) {
                invalid.title = 'Oops!';
                invalid.errMsg = 'Your application is unsuccessful. <Code '+errType+'>\n\nYou may reapply 12 months after your last application.';
                invalid.btnType = btnType.BacktoHome;
                invalid.code = errType;
            }
            else {
                let temp = errType.split(',');
                let desp = [];
                if(temp[0] === myInfoError.Code_M02) {  //M02
                    for (let i in temp) {
                        if(i !== '0') {
                          desp.push(temp[i]) ;
                        }  
                    }
                    invalid.title = 'Oops!';
                    invalid.btnType = btnType.BacktoHome;
                    invalid.errMsg = 'We are unable to retrieve the required information.\nDo update the missing details in Myinfo and reapply with us. <Code '+temp[0]+'>';
                    invalid.errDesp = desp;
                    invalid.code = temp[0];
                }
                else { //others, show default
                    invalid.title = 'Oops!';
                    invalid.errMsg = "We are unable to proceed your application.";
                    invalid.btnType = btnType.GetInTouch;
                    invalid.code='xxxx';
                }
            }
        }
        else {//show default
            invalid.title = 'Oops!';
            invalid.errMsg = "We are unable to proceed your application.";
            invalid.btnType = btnType.GetInTouch;
            invalid.code='xxxx';
        }

        setDisplayErrMsg(invalid);
    }

    return(
        <FormContainer>
            <div className="row around-xs elementVisible">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <legend id={'lmsg1'} style={{textAlign:'center',paddingTop:'20px'}}>{displayErrMsg.title}</legend>
                </div>
            </div>
            <div style={{paddingTop: "10px"}}><hr className="yellowPanelLine" /></div>
              
            <div className="row around-xs inputPair elementVisible">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <div id={'lmsg1'} style={{textAlign:'center',paddingTop:'20px',whiteSpace:'pre-line',fontSize:'1.1rem'}}>{displayErrMsg.errMsg}</div>
                </div>
            </div>

            {(displayErrMsg.code === myInfoError.Code_M27)&&
                <>
                <div className="row around-xs inputPair elementVisible">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="box">
                            <FaCheck color='green'/>&nbsp;&nbsp;&nbsp;{'Business is incorporated in Singapore '} 
                        </div>
                        <br/>
                        <div className="box">
                            <FaTimes color='red'/>&nbsp;&nbsp;&nbsp;{'Business has up to 10 Singaporeans/Singapore PRs Partners, Business Owner, Directors, Shareholders'} 
                        </div>  
                    </div>
                </div>
                <div className="row around-xs inputPair elementVisible">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        {'For assistance, do get in touch.'}
                    </div>
                </div>
                </>
            }
          
            <div>
                <div id={'lmsg1'} style={{textAlign:'center',paddingTop:'20px',whiteSpace:'pre-line',fontSize:'0.9rem'}}>
                    {displayErrMsg.code === myInfoError.Code_M02 &&
                    <div><u>Missing fields:</u><br/>
                        {displayErrMsg.errDesp.map((item, idx) => (
                            <div key={idx}>{item}</div> 
                        ))}
                    </div>
                    }
                    {displayErrMsg.code === myInfoError.Code_M04 &&
                    <p>- Residential status</p>
                    }
                </div>
            </div>

            <br/>
            
            {displayErrMsg.btnType === btnType.GetInTouch &&
            <div className="row around-xs inputPair elementVisible">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12" style={{ paddingBottom: "20px" }}>
                    <button type={'submit'} className="k-button btn-success" onClick={handleGetInTouchClick}>{'Get in Touch'}</button>
                    <button className="k-button btn-back btn-float-right" onClick={handleCancelClick}>{'Cancel'}</button>
                </div>
            </div>  
            }

            {displayErrMsg.btnType === btnType.ResumeApp &&
            <div className="row around-xs inputPair elementVisible">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12" style={{ paddingBottom: "20px" }}>
                    <button type={'submit'} className="k-button btn-success" onClick={handleResumeAppClick}>{'Resume Application'}</button>
                    <button className="k-button btn-back btn-float-right" onClick={handleCancelClick}>{'Cancel'}</button>
                </div>
            </div>  
            }

            {displayErrMsg.btnType === btnType.BacktoHome &&
            <div className="row around-xs inputPair elementVisible">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <div style={{textAlign:'center'}}>
                        <button className="k-button btn btn-success" onClick={handleBacktohomeClick}>{'Back to home'}</button>
                    </div>
                </div>
            </div>  
            }
            <br/>
        </FormContainer>
    )
}

export default InvalidEntity;